import MotionLazyContainer from "components/animate/MotionLazyContainer";
import { useEffect, useState } from "react";
import ThemeSettings from "components/theme-settings";
import useAppTheme from "hooks/useAppTheme";
import ScrollToTop from "components/scroll-to-top";
import Router from "routes/Router";
import { LocaleProvider } from "contexts/LocaleContext";
import { DialogProvider } from "contexts/DialogContext";
import { CustomDrawerProvider } from "contexts/CustomDrawerContext";
import addLicense from "configs/addLicense";
import { BreadcrumbProvider } from "contexts/BreadcrumbsContext";
import { useAuth0 } from "@auth0/auth0-react";
import { useGetApiToken } from "hooks/useAuth";
import FullPageLoader from "components/loaders/FullPageLoader";
import { DEFAULT_LOGIN_OPTIONS } from "constants/auth-constants";
import { setupApiConnections } from "utils/axios";
import { AuthProvider } from "contexts/AuthContext";

export default function App() {
  const { onResetAppTheme } = useAppTheme();
  const { isAuthenticated, isLoading, loginWithRedirect } = useAuth0();
  const [appIsReady, setAppIsReady] = useState(false);
  const [apiConnectionsEnabled, setApiConnectionsEnabled] = useState(false);
  const { getApiToken } = useGetApiToken();

  // Set tokens once authenticated
  useEffect(() => {
    if (isLoading || !isAuthenticated)
      return;

    setupApiConnections(getApiToken, loginWithRedirect);
    setApiConnectionsEnabled(true);
  }, [isAuthenticated, isLoading, getApiToken, loginWithRedirect]);

  useEffect(() => {
    if (process.env.DATA_GRID_PREMIUM_KEY) {
      addLicense({ dataGridProKey: process.env.DATA_GRID_PREMIUM_KEY });
    }
  }, []);

  useEffect(() => {
    if (!isAuthenticated) {
      onResetAppTheme();
    }
  }, [isAuthenticated, onResetAppTheme]);

  useEffect(() => {
    const redirectIfNeeded = async () => {
      if (!isLoading && !isAuthenticated && !appIsReady) {
        await loginWithRedirect(DEFAULT_LOGIN_OPTIONS);
      }
    };
    redirectIfNeeded();
  }, [isAuthenticated, isLoading, loginWithRedirect, appIsReady]);

  useEffect(() => {
    if (isLoading || !isAuthenticated || !apiConnectionsEnabled) return;
    setAppIsReady(true);
  }, [isAuthenticated, isLoading, apiConnectionsEnabled]);

  if (isLoading || !appIsReady) {
    return <FullPageLoader />;
  }


  return (
    <AuthProvider>
      <MotionLazyContainer>
        {/* <SignalRProvider token={token}> */}
          <ThemeSettings>
            <LocaleProvider>
              <BreadcrumbProvider>
                  <DialogProvider>
                    <ScrollToTop />
                    <CustomDrawerProvider>
                      <Router />
                    </CustomDrawerProvider>
                  </DialogProvider>
              </BreadcrumbProvider>
            </LocaleProvider>
          </ThemeSettings>
        {/* </SignalRProvider> */}
      </MotionLazyContainer>
    </AuthProvider>
  );
}
